export default {
  name: 'loader',
  props: {
    variant: {
      type: String,
      default: 'spin',
    },
  },
};
